import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import Layout from '../components/Layout/Layout';
import Input from '../components/UI/Input';
import Button from '../components/UI/Button';
import { useLanguage } from '../contexts/LanguageContext';
import dataService from '../services/dataService';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import supabase from '../lib/supabase';

const { FiSearch, FiUser } = FiIcons;

const Lookup = () => {
  const [regNo, setRegNo] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { t } = useLanguage();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!regNo.trim()) {
      setError('requiredField');
      return;
    }

    setLoading(true);
    setError('');

    try {
      console.log("Looking up teacher with reg_no:", regNo.trim());
      
      // Get teacher record from local storage first
      const teacher = dataService.getTeacherByRegNo(regNo.trim());
      
      if (teacher) {
        console.log("Teacher found in local storage:", teacher);
        navigate(`/results/${teacher.reg_no}`);
      } else {
        // If not found in local storage, try to get from Supabase
        try {
          console.log("Searching Supabase for teacher with reg_no:", regNo.trim());
          const { data, error } = await supabase
            .from('teachers_x7a9b3c4d2')
            .select('*')
            .eq('reg_no', regNo.trim())
            .maybeSingle();

          if (error) {
            console.error("Supabase query error:", error);
            throw error;
          }

          if (data) {
            console.log("Teacher found in Supabase:", data);
            // Calculate scores and save to local storage for future reference
            const calculatedTeacher = dataService.calculateScores(data);
            dataService.saveTeacher(calculatedTeacher);
            navigate(`/results/${calculatedTeacher.reg_no}`);
          } else {
            console.log("Teacher not found in Supabase");
            setError('noResults');
          }
        } catch (supabaseError) {
          console.error('Supabase error:', supabaseError);
          setError('noResults');
        }
      }
    } catch (err) {
      console.error('Error during lookup:', err);
      setError('noResults');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout>
      <div className="max-w-md mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="bg-white rounded-lg shadow-lg p-8"
        >
          <div className="text-center mb-8">
            <div className="w-16 h-16 bg-minecraft-green rounded-full flex items-center justify-center mx-auto mb-4">
              <SafeIcon icon={FiUser} className="w-8 h-8 text-white" />
            </div>
            <h2 className="text-2xl font-bold text-gray-900 mb-2">
              {t('title')}
            </h2>
            <p className="text-gray-600">
              {t('enterRegNumber')}
            </p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-6">
            <Input
              label={t('registrationNumber')}
              value={regNo}
              onChange={(e) => setRegNo(e.target.value)}
              placeholder={t('registrationNumber')}
              error={error}
              required
            />

            <Button
              type="submit"
              variant="primary"
              size="lg"
              disabled={loading}
              className="w-full"
            >
              {loading ? (
                <span>{t('loading')}</span>
              ) : (
                <>
                  <SafeIcon icon={FiSearch} className="w-5 h-5" />
                  <span>{t('displayResults')}</span>
                </>
              )}
            </Button>
          </form>
        </motion.div>
      </div>
    </Layout>
  );
};

export default Lookup;